module.exports = __webpack_public_path__ + "0cde8fe24d1c058078a15f5790b07f0a.MP3";